document.querySelectorAll(".js-scroll").forEach((anchor) => {
  anchor.addEventListener("click", function (e) {
    e.preventDefault();

    const target = document.querySelector(this.getAttribute("href"));
    if (!target) return;

    const headerOffset = 90;
    const elementPosition = target.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".header-wrapper");
  const fv = document.querySelector(".fv-wrapper");

  if (!header || !fv) return;

  let lastScroll = 0;

  window.addEventListener("scroll", function () {
    const currentScroll = window.pageYOffset;
    const fvHeight = fv.offsetHeight;

    // ===== FV通過判定 =====
    if (currentScroll > fvHeight - 80) {
      header.classList.add("is-scrolled");

      // ===== FV通過後のみ、隠す処理を有効化 =====
      if (currentScroll > lastScroll && currentScroll > fvHeight + 50) {
        header.classList.add("is-hidden");
      } else {
        header.classList.remove("is-hidden");
      }
    } else {
      // FV内では絶対に消さない
      header.classList.remove("is-scrolled");
      header.classList.remove("is-hidden");
    }

    lastScroll = currentScroll;
  });
});

$(".slider").slick({
  autoplay: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  centerMode: true,
  centerPadding: "10%",
  prevArrow: '<button type="button" class="slick-prev"></button>',
  nextArrow: '<button type="button" class="slick-next"></button>',
  dots: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        variableWidth: false, // ← ここが重要
        slidesToShow: 1,
        centerMode: true,
        centerPadding: "0%", // ← 見せたいチラ見せ量を調整
      },
    },
    {
      breakpoint: 480,
      settings: {
        variableWidth: false,
        slidesToShow: 1,
        centerMode: false, // ← SPは中央寄せやめる場合
      },
    },
  ],
});

//アコーディオンをクリックした時の動作
$(".title").on("click", function () {
  //タイトル要素をクリックしたら
  var findElm = $(this).next(".box"); //直後のアコーディオンを行うエリアを取得し
  $(findElm).slideToggle(); //アコーディオンの上下動作

  if ($(this).hasClass("close")) {
    //タイトル要素にクラス名closeがあれば
    $(this).removeClass("close"); //クラス名を除去し
  } else {
    //それ以外は
    $(this).addClass("close"); //クラス名closeを付与
  }
});

//任意のタブにURLからリンクするための設定
function GethashID(hashIDName) {
  if (hashIDName) {
    //タブ設定
    $(".tab li")
      .find("a")
      .each(function () {
        //タブ内のaタグ全てを取得
        var idName = $(this).attr("href"); //タブ内のaタグのリンク名（例）#lunchの値を取得
        if (idName == hashIDName) {
          //リンク元の指定されたURLのハッシュタグ（例）http://example.com/#lunch←この#の値とタブ内のリンク名（例）#lunchが同じかをチェック
          var parentElm = $(this).parent(); //タブ内のaタグの親要素（li）を取得
          $(".tab li").removeClass("active"); //タブ内のliについているactiveクラスを取り除き
          $(parentElm).addClass("active"); //リンク元の指定されたURLのハッシュタグとタブ内のリンク名が同じであれば、liにactiveクラスを追加
          //表示させるエリア設定
          $(".area").removeClass("is-active"); //もともとついているis-activeクラスを取り除き
          $(hashIDName).addClass("is-active"); //表示させたいエリアのタブリンク名をクリックしたら、表示エリアにis-activeクラスを追加
        }
      });
  }
}

//タブをクリックしたら
$(".tab a").on("click", function () {
  var idName = $(this).attr("href"); //タブ内のリンク名を取得
  GethashID(idName); //設定したタブの読み込みと
  return false; //aタグを無効にする
});

// 上記の動きをページが読み込まれたらすぐに動かす
$(window).on("load", function () {
  $(".tab li:first-of-type").addClass("active"); //最初のliにactiveクラスを追加
  $(".area:first-of-type").addClass("is-active"); //最初の.areaにis-activeクラスを追加
  var hashName = location.hash; //リンク元の指定されたURLのハッシュタグを取得
  GethashID(hashName); //設定したタブの読み込み
});

// hrefが#で始まる同ページへのアンカー全てに対して
document.querySelectorAll('a[href^="#"]').forEach((element) => {
  element.addEventListner("click", (event) => {
    // 元々のクリックイベントを無効化
    event.preventDefault();
    // 履歴を設定せずにページ遷移
    location.replace(element.href);
  });
});

var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = "_blank";
    links[i].rel = "noreferrer noopener";
  }
}

// 初期化
const lenis = new Lenis({
  autoRaf: true, // requestAnimationFrameでスクロール処理を継続的に更新するかどうか
});
